<section class="landing-login parking-lotpage">
  <app-header-v1 [presentComponent]="presentComponent"></app-header-v1> 
  <div class="parkinglot-bannersec">
    <div class="bg-img">
      <img
        src="../../assets/images/landing-page/parking-banner-bg.png"
        alt="Banner Background"
        class="img-fluid"
      />
    </div>
    <div class="landing-container">
      <h1 class="banner-heading">
        The Best Management System for Parking Lot Managers
      </h1>

      <div class="banner-btnbox">
        <a routerLink="/onboarding" class="banner-btn-outline">
          Sign-up as Parking Lot Admin
        </a>
        <a routerLink="/login" class="banner-btn">
          Login as Parking Lot Manager
        </a>
      </div>
      <div class="banner-img">
        <img
          src="../../assets/images/landing-page/parkinglog-bannerimg.png"
          alt="banner"
          class="img-fluid"
        />
      </div>   
      <app-feature-box [features]="features"></app-feature-box>
    </div>
  </div>

<div class="comunity-sec">
    <div class="map-box">
      <app-join-our-community-map></app-join-our-community-map>
    </div>
  </div>
</section>
<app-footer></app-footer>
